import { localize } from "@/i18n/translate";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
const AuthCtx = createContext(null);
export const AuthProvider = ({
  children
}) => {
  const [user, setUser] = useState(null);
  const reload = useCallback(async () => {
    try {
      const {
        data
      } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (e) {
      try {
        const {
          data
        } = await api.post("/auth/refresh");
        setUser(data);
        return data;
      } catch (e2) {
        setUser(false);
        return false;
      }
    }
  }, []);
  useEffect(() => {
    reload();
  }, [reload]);
  const login = useCallback(async (email, password) => {
    const {
      data
    } = await api.post("/auth/login", {
      email,
      password
    });
    setUser(data);
    return data;
  }, []);
  const register = useCallback(async payload => {
    const {
      data
    } = await api.post("/auth/register", payload);
    if (!data.verification_required) setUser(data);
    return data;
  }, []);
  const verifyEmail = useCallback(async (challenge_id, code) => {
    const { data } = await api.post('/auth/verify-email', { challenge_id, code });
    setUser(data);
    return data;
  }, []);
  const resendEmail = useCallback(async challenge_id => {
    const { data } = await api.post('/auth/resend-email', { challenge_id });
    return data;
  }, []);
  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setUser(false);
    }
  }, []);
  const value = useMemo(() => ({
    user,
    setUser,
    reload,
    login,
    register,
    verifyEmail,
    resendEmail,
    logout
  }), [user, reload, login, register, verifyEmail, resendEmail, logout]);
  return <AuthCtx.Provider value={value}>{localize(children)}</AuthCtx.Provider>;
};
export const useAuth = () => useContext(AuthCtx);
